import React from 'react';
import { Tabs, Tab } from '@mui/material';
import styled from 'styled-components';
import { brand, darkgrey, grey } from 'styles/Colors';

export const StyledTabs = styled((props) => <Tabs {...props} />)`
  & .MuiTabs-indicator {
    background-color: ${brand};
    bottom: '-2px';
  }
`;

export const StyledTab = styled((props) => <Tab {...props} />)`
  &.MuiTab-root {
    font-family: 'Oswald';
    font-size: 15px;
    font-weight: 500;
    padding: 0;
    margin-bottom: 5px;
    color: ${grey};
    min-width: 109px;

    &:not(:last-child) {
      margin-right: 20px;
    }

    &.Mui-selected {
      color: ${darkgrey};
    }

    &:focus {
      outline: none;
    }
  }
  &:hover {
    opacity: 1;
  }
`;
